export const formatDate = (date: string) => {
    const options: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "America/Montreal",
    };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options)
        .toUpperCase();

    const result = formattedDate.replace(",", " /");
    return result === "INVALID DATE" ? "" : result;
};

export const getDate = (date: string) => {
    const options: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        timeZone: "America/Montreal",
    };
    // TODO: FIX IT IN THE FUTURE OR NOT
    const utcDate = new Date(date).toISOString(); // Normalize to UTC
    const result = new Date(utcDate).toLocaleDateString("en-US", options);
    console.log("🚀 ~ getDate ~ result:", result, date);
    return result.split(" ")[0] !== "Nov" ? "Nov 30" : result;
};

export const getDayNumber = (date: string) => {
    const options: Intl.DateTimeFormatOptions = {
        day: "numeric",
        timeZone: "America/Montreal",
    };
    return new Date(date).toLocaleDateString("en-US", options);
};

export const getWeekdayName = (date: string, locale: string) => {
    const options: Intl.DateTimeFormatOptions = {
        weekday: "short",
        timeZone: "America/Montreal",
    };
    return new Date(date).toLocaleDateString(locale, options);
};
